import type { ModelSelection, ScopedThreadRef } from "@cmmd-forge/contracts";
import type { ComponentProps } from "react";
import type { DraftId } from "../../draftId";
import { useComposerDraftStore } from "../../composerDraftStore";
import { useProviderUsageRead } from "../../usage/useProviderUsage";
import { ProviderModelPicker } from "./ProviderModelPicker";

export interface ComposerAccountSelection {
  readonly target: ScopedThreadRef | DraftId;
  readonly modelSelection: ModelSelection;
}

/** Account choices update the same draft that the next turn reads. */
export function ComposerAccountModelPicker({
  accountSelection,
  ...props
}: ComponentProps<typeof ProviderModelPicker> & {
  readonly accountSelection: ComposerAccountSelection;
}) {
  const usage = useProviderUsageRead();
  const setModelSelection = useComposerDraftStore((store) => store.setModelSelection);
  const selection = accountSelection.modelSelection;
  return (
    <ProviderModelPicker
      {...props}
      providerAccounts={usage.accounts.map(({ account }) => account)}
      {...("providerAccountId" in selection && selection.providerAccountId
        ? { selectedProviderAccountId: selection.providerAccountId }
        : {})}
      onProviderAccountChange={(provider, providerAccountId) => {
        if (selection.provider !== provider) return;
        setModelSelection(accountSelection.target, { ...selection, providerAccountId });
      }}
    />
  );
}
